module.exports = __webpack_public_path__ + "static/the-dice-man-21227860e4e4c560dbd5b74ddac61575.jpg";